import { render, staticRenderFns } from "./step-4.vue?vue&type=template&id=db22e382&scoped=true&"
import script from "./step-4.vue?vue&type=script&lang=js&"
export * from "./step-4.vue?vue&type=script&lang=js&"
import style0 from "./step-4.vue?vue&type=style&index=0&id=db22e382&lang=scss&scoped=true&"
import style1 from "./step-4.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db22e382",
  null
  
)

export default component.exports